import { ReactElement, useContext } from 'react';
import { getGiveawayAssets, GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';
import { GiveawayContext } from '@/state/state';
import { ImageGallery } from '../gallery/gallery';
import { CLUSTER_BUTTON_TYPES } from '@/enums/ClusterButton';
import { MoonIcon } from '@/common/icons/Moon';
import { SunIcon } from '@/common/icons/Sun';
import { GALLERY_DATA } from '../clusterButton/ClusterButton.types';
import { useTranslation } from 'react-i18next';

export const Interior = (): ReactElement | null => {
  const giveawayData: GiveawayResponse = useContext(GiveawayContext);
  const assetDay = getGiveawayAssets(giveawayData, 'interior');
  const assetNight = getGiveawayAssets(giveawayData, 'interior-night');
  const { t } = useTranslation();

  if (!assetDay?.length && !assetNight?.length) {
    return null;
  }

  const tabData: GALLERY_DATA[] = [
    {
      name: CLUSTER_BUTTON_TYPES.DAY,
      icon: <SunIcon aria-hidden="true" />,
      ariaLabel: t('clusterButtons.dayImagesAriaLabel'),
      images: assetDay,
    },
  ];

  if (assetNight?.length) {
    tabData.push({
      name: CLUSTER_BUTTON_TYPES.NIGHT,
      icon: <MoonIcon aria-hidden="true" />,
      ariaLabel: t('clusterButtons.nightImagesAriaLabel'),
      images: assetNight,
    });
  }

  return (
    <ImageGallery
      displayTabs={tabData.length > 1}
      tabData={tabData}
      labelPrefix="Interior"
      name={CLUSTER_BUTTON_TYPES.INTERIOR}
      displaySubTitle
    />
  );
};
